<template>
  <el-row class="el-row-slider">
    <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
      <el-menu default-active="1"
               class="el-menu-vertical-demo"
               :unique-opened="true"
               @open="handleOpen"
               @close="handleClose"
               @select="handleClick"
               background-color="#001f3f"
               active-background-color="rgb(52, 53, 53)"
               text-color="#fff"
               :collapse="isCollapse">

        <el-menu-item style="text-align: center;line-height: 60px;color: white">
          <span style="font-size: 3em; color: orange;font-weight: bold"> BOSS</span>

        </el-menu-item>
        <template v-for="(item,index) in menu.child" v-if="item.visible">
          <el-submenu  v-if="item.child&&item.child.length>0" :index="index+''">
            <template slot="title">
              <i :class="item.iconCls"></i>
              <span>{{item.name}}</span>
            </template>
            <el-menu-item v-for="(child,x) in item.child" :index="index+'-'+x" :key="child.path" v-if="!child.hidden">
              <i :class="child.iconCls"></i>
              <span >{{child.name}}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-if="!item.child" :index="index+''">
            <i :class="item.iconCls"></i>
            <span>{{item.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-col>
  </el-row>

</template>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

  .el-menu {
    border-right: none !important;
    height: 100%;
  }

  .el-row-slider {
    background-color: #001f3f;
  }
</style>

<script>
  import trans from '../../transform/trans'
  import menus from '../../transform/menus'

  export default {
    data() {
      return {
        isCollapse: false,
        menu: menus
      };
    },
    created: function () {
      trans.$on('collapse-slider', (data) => {
        this.isCollapse = data;
      });
    },
    mounted() {
      trans.$emit('select-slider', menus.child[0]);
    },
    methods: {
      handleOpen(key, keyPath) {
      },
      handleClose(key, keyPath) {
      },
      handleClick(key, keyPath) {
        let keys=key.split("-");
        trans.$emit('select-slider', keys.length === 2 ? menus.child[keys[0]].child[keys[1]] : menus.child[keys[0]]);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/commerical/CommmericalSlider.vue